import * as React from "react"
import { observer } from "mobx-react"
import { SessionEditor } from "./SessionEditor"
import { PassesStep } from "./PassesStep"
import { Flex, Text, Button } from "rebass"
import theme from "../../theme"
import Select from "../../components/Select"
import { PassesMemberPicker } from "./PassesMemberPicker"
import StyledCard from "BookingSystem/components/StyledCard"
import { $Session, Session } from "BookingSystem/db/Session"
import { SessionType } from "BookingSystem/db/SessionType"
import { runInAction } from "mobx"
import { TableHeading } from "BookingSystem/components/TableHeading"
import styled from "styled-components"

@observer
export class SessionCard extends React.Component<{ model: SessionEditor }> {
  render() {
    const { model } = this.props
    const sessionGroup = model.sessionGroup
    const session = sessionGroup.session
    const sessionType = session.sessionType

    return (
      <Flex
        flexDirection={"column"}
        style={{
          maxWidth: "95vw"
        }}
      >
        <Flex
          flexDirection="column"
          className="card"
          style={{
            flex: 1,
            width: 580,
            margin: "2%"
          }}
        >
          <Flex
            flexDirection="row"
            className="card-header"
            m={1}
            p={1}
            style={{ alignItems: "center" }}
          >
            <Flex className="card-header-title">
              <Flex>{sessionType.object.name}</Flex>
              <Flex style={{ marginLeft: 15 }}>
                <Select
                  passes
                  value={sessionGroup.session.id}
                  onChange={(e: any) => {
                    runInAction(() => {
                      sessionGroup.object.$session = e.target.value
                      sessionGroup.session.object = model.db.file.objects[
                        e.target.value
                      ] as $Session
                    })
                  }}
                >
                  {sessionType
                    .sessionsForDay(model.flow.currentBooking.arrivingDate)
                    .map((session: Session, i: any) => (
                      <option
                        key={i}
                        disabled={
                          !model.flow.currentBooking.isSessionAvailable(session)
                        }
                        value={session.id}
                      >
                        {session.timeSlot}
                      </option>
                    ))}
                </Select>
              </Flex>
            </Flex>
          </Flex>
          <Flex className="card-content">
            {model.memberList.length === 0 ? (
              <Flex />
            ) : (
              <PassesMemberPicker model={model} />
            )}
          </Flex>
        </Flex>
      </Flex>
    )
  }
}

const Pill = function({
  text,
  backgroundColor
}: {
  text: string
  backgroundColor: string
}) {
  return (
    <Flex width={0.3} color={theme.colors.white}>
      <Text
        fontWeight="bold"
        style={{
          width: 100,
          height: 28,
          background: backgroundColor,
          borderRadius: 4,
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {text}
      </Text>
    </Flex>
  )
}

const colorForSessionType = function(sessionType: SessionType): string {
  const name = sessionType.object.name.toLowerCase()
  switch (name) {
    case "jump mo":
      return theme.colors.activityButton1
    case "climb mo":
      return theme.colors.activityButton2
    case "play mo":
      return theme.colors.activityButton3
    case "observe mo":
      return theme.colors.activityButton4
  }
  return theme.colors.activityButton1
}

@observer
export class PassesStepComp extends React.Component<{ model: PassesStep }> {
  componentDidMount() {
    this.props.model.componentDidMount()
  }

  componentWillUnmount() {
    this.props.model.componentWillUnMount()
  }

  render() {
    const { model } = this.props
    const sessionTypes = model.flow.sessionTypes

    const PassesTableHeading = styled(TableHeading)`
      margin-left: 0;
      padding-left: 0;
    `

    const children = [
      <Flex
        flexDirection="column"
        justifyContent="space-between"
        alignItems="space-around"
        width={["95vw", 0.95, 0.95, 900]}
        key={0}
      >
        <StyledCard
          mt={0}
          p={2}
          style={{
            width: "100%",
            maxWidth: 900,
            alignSelf: "flex-start",
            backgroundColor: theme.colors.black
          }}
        >
          <Flex
            flexDirection={"row"}
            alignItems={"flex-end"}
            justifyContent={"space-between"}
            width={1}
            ml={4}
          >
            <Flex alignItems="center" color={theme.colors.white} mt={2}>
              <Text
                color={theme.colors.white}
                mb={2}
                fontSize={["1.2rem", "1.2rem", "2rem"]}
              >
                {`Group Schedule (${model.flow.currentBooking.arrivingDate.format(
                  "dddd MMM DD"
                )})`}
              </Text>
            </Flex>
          </Flex>
          <Flex
            mb={1}
            ml={4}
            style={{ borderBottom: "solid 1px rgba(255,255,255, 0.1)" }}
          >
            <PassesTableHeading width={0.3}>Name</PassesTableHeading>
            <PassesTableHeading width={0.3}>Activity</PassesTableHeading>
            <PassesTableHeading width={0.3}>Time</PassesTableHeading>
            <PassesTableHeading width={0.1} />
          </Flex>
          {model.activityPlan.map((plan, i) => (
            <Flex alignItems="center" key={i} style={{ height: 45 }} ml={4}>
              <Text
                width={0.3}
                color={theme.colors.white}
                fontSize={["0.75rem", "1rem", "1.25rem"]}
              >
                {plan.member.shortName}
              </Text>
              <Pill
                text={plan.sessionGroup.session.description}
                backgroundColor={colorForSessionType(
                  plan.sessionGroup.session.sessionType
                )}
              />
              <Text
                width={0.3}
                color={theme.colors.white}
                fontSize={["0.75rem", "1rem", "1.25rem"]}
              >
                {`${plan.sessionGroup.session.timeSlot} - ${
                  plan.sessionGroup.session.endTimeString
                }`}
              </Text>
              <Flex>
                <i
                  className="fas fa-trash-alt"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    plan.sessionGroup.removeMember(plan.member)
                  }}
                />
              </Flex>{" "}
            </Flex>
          ))}
        </StyledCard>
      </Flex>
    ]

    const buttons = (
      <Flex
        flexDirection={["column", "row"]}
        key={"first"}
        justifyContent={["space-between"]}
        alignItems={["center"]}
        bg={theme.colors.secondaryBlack}
        p={4}
        width={["95vw", 0.95, 0.95, 900]}
        style={{
          flexWrap: "wrap"
        }}
      >
        {sessionTypes &&
          sessionTypes.map((sessionType, i) => (
            <Button
              key={i}
              className={sessionType.object.name
                .toLowerCase()
                .replace(" ", "-")}
              onClick={() => model.addPass(sessionType)}
              px={2}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                background: colorForSessionType(sessionType),
                borderRadius: 4,
                height: 40,
                color: theme.colors.white,
                fontWeight: "bold",
                fontSize: 17,
                width: 150,
                textTransform: "uppercase"
              }}
            >
              <i
                style={{
                  marginRight: 3,
                  fontSize: window.innerWidth > 450 ? "1rem" : "0.75rem"
                }}
                className="fas fa-plus"
              />
              {`${sessionType.object.name}`}
            </Button>
          ))}
      </Flex>
    )

    children.unshift(buttons)

    return (
      <Flex
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          marginTop: "2%",
          width: "85%",
          padding: "2%"
        }}
      >
        {children}
      </Flex>
    )
  }
}
